import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchStudents } from '../../store/actions/studentActions';
import { MultiSelect } from 'primereact/multiselect'; // <-- Add this import
// import { baseUrlAdmin } from '../../../store/apiConstants';
import { Button } from 'primereact/button';





class ClassetStudentSearchFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: [],
            filterValue: '',  // Add this to control filter value
            isOpen: false    // Add this to track dropdown state
        };
        
        // Expose the component instance via forwardedRef
        if (props.forwardedRef) {
            props.forwardedRef.current = this;
        }
    }

    componentDidMount() {
        if (!this.props.students || this.props.students.length === 0) {
            this.props.fetchStudents();
        }
        
        // Update the ref if it exists
        if (this.props.forwardedRef) {
            this.props.forwardedRef.current = this;
        }
    }

    componentDidUpdate(prevProps) {
        // Clear state when disabled (i.e., when selectedValue changes to 1)
        if (
            prevProps.selectedValue !== this.props.selectedValue &&
            this.props.selectedValue === 1
        ) {
            this.setState({ searchValue: [] });
        }
    }

    handleValueChange = (value) => {
        // If singleSelectInput is true, only allow the last selected value
        if (!this.props.singleSelectInput) {
            this.setState({ searchValue: value });
        } else {
            this.setState({ searchValue: value ? value.slice(-1) : [] });
        }
    };
    // handleValueChange = (value) => {
    //     if (this.props.singleSelectInput) {
    //         this.setState({ searchValue: value });
    //     } else {
    //         // Only allow one selection in MultiSelect
    //         this.setState({ searchValue: value ? value.slice(-1) : [] });
    //     }
    //     // (e) => {
    //     // if (this.props.singleSelectInput) {
    //     //     // Only allow one selection
    //     //     this.handleValueChange(e.value ? e.value.slice(-1) : []);
    //     // } else {
    //     //     this.handleValueChange(e.value);
    //     // }
    //     // }

    // };

    // handleValueChange = (value) => {
    // if (this.props.singleSelectInput) {
    //     // Only allow one selection (the last one)
    //     this.setState({ searchValue: value ? [value[value.length - 1]] : [] });
    // } else {
    //     // Allow multiple selections
    //     this.setState({ searchValue: value });
    // }
    // };

    clearInput = () => {
        this.setState({ searchValue: [] });
    };

    // Method to programmatically set selected students (called from parent via ref)
    setSelectedStudents = (studentIds, retryCount = 0) => {
        if (!studentIds || studentIds.length === 0) {
            this.setState({ searchValue: [] });
            return;
        }

        const { students, fetchStudents } = this.props;
        
        // If students aren't loaded, trigger fetch and retry
        if (!students || students.length === 0) {
            if (retryCount === 0) {
                console.log('Students not loaded, fetching...');
                fetchStudents();
            }
            
            if (retryCount < 50) { // Max 5 seconds (50 * 100ms)
                setTimeout(() => this.setSelectedStudents(studentIds, retryCount + 1), 100);
            } else {
                console.warn('Failed to load students after multiple retries');
            }
            return;
        }

        console.log('Setting selected students:', studentIds, 'from', students.length, 'students');

        // Find student objects matching the provided IDs
        const selectedStudents = students.filter(student => 
            studentIds.includes(student.user_id)
        );

        console.log('Found students:', selectedStudents);

        if (selectedStudents.length > 0) {
            this.setState({ searchValue: selectedStudents }, () => {
                console.log('Search value updated to:', this.state.searchValue);
            });
        } else {
            console.warn('No students found matching IDs:', studentIds);
        }
    };

    // Add these new methods
    handleFilter = (e) => {
        this.setState({ filterValue: e.filter });
    };

    handleHide = () => {
        this.setState({
            filterValue: '',
            isOpen: false
        });
    };

    render() {
        const { searchValue } = this.state;
        const { students, loading, singleSelectInput } = this.props;

        return (
            <>
                {/* Internal CSS for dropdown styling */}
                <style>
                    {`
                    .classet-student-search-dropdown .p-multiselect-label {
                        font-size: 16px;
                        color: var(--text-color, #222);
                    }
                    .classet-student-search-dropdown .p-multiselect-panel {
                        border-radius: 8px !important;
                        box-shadow: 0 4px 16px rgba(0,0,0,0.08) !important;
                    }
                    .classet-student-search-dropdown .p-multiselect-item {
                        font-size: 15px;
                    }
                    .classet-student-search-dropdown {
                        min-width: 400px;
                        border-radius: 8px;
                        background: var(--surface-0, #fff);
                        border: 1px solid var(--surface-200, #eee) !important;
                        box-shadow: 0 2px 8px rgba(0,0,0,0.08) !important;
                    }
                    /* Hide checkboxes when in single select mode */
                    .single-select .p-checkbox {
                        display: none !important;
                    }
                    `}
                </style>

                <div className="flex mt-4">
                    <div className="field flex flex-column">
                        <label
                            className="ma-label-s2 font-serif font-semibold text-900 text-lg  undefined">
                            Search Student
                            {/* <span className="ma-required">*</span> */}
                        </label>
                        {/* <InputText /> */}
                        <MultiSelect
                            options={students}
                            optionLabel={(option) => {
                                const name =
                                    (option.user_info && (
                                        // option.user_info.given_name ||
                                        ((option.user_info.firstName || '') + ' ' + (option.user_info.lastName || '')).trim().replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
                                    )) || '';
                                const enrollmentId =
                                    (option.enrollmentId || (option.user_info && option.user_info.enrollmentId) || '')
                                return `${name} - ${enrollmentId}`;
                            }}
                            filter
                            showClear
                            display={singleSelectInput ? "chip" : "chip"}
                            style={{
                                width: "600px",
                                height: "44px",
                                borderRadius: "8px",
                                fontSize: "16px",
                                background: "var(--surface-0)",
                                border: "1px solid #eee",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                margin: "-3px 16px 0 0"
                            }}
                            panelClassName="p-autocomplete-panel classet-student-search-dropdown"
                            className={`pr-2 text-xl pl-2 no-border border-none pt-2 classet-student-search-dropdown ${singleSelectInput ? 'single-select' : ''}`}
                            value={searchValue}
                            onChange={(e) => this.handleValueChange(e.value)}
                            filterValue={this.state.filterValue}
                            onFilter={this.handleFilter}
                            onHide={this.handleHide}
                            resetFilterOnHide
                            selectionMode={singleSelectInput ? "single" : "multiple"}
                            showSelectAll={!singleSelectInput}
                            placeholder="Search Students by Name or ID"
                            disabled={this.props.selectedValue === 1}

                            // optionDisabled={() => true} //disable all options
                            // optionDisabled={(option) => option.isInactive}
                            maxSelectedLabels={1} // optional, for display
                        />


                    </div>

                    <Button
                        style={{
                            marginTop: "25px",
                            marginLeft: "16px",
                            height: "44px",
                            borderRadius: "8px",
                            fontSize: "16px",
                            background: "#076EFF",
                            color: "#fff",
                            border: "none",
                            padding: "0 24px",
                            cursor: "pointer"
                        }}
                        disabled={this.props.selectedValue === 1 || !this.state.searchValue || this.state.searchValue.length === 0}
                        onClick={() => {
                            console.log("Search button clicked with searchValue:", this.state.searchValue);
                            if (this.props.setValues) {
                                const selected = this.state.searchValue || [];
                                // Build payload with both studentIds and enrollmentIds arrays
                                const payload = {
                                    studentIds: selected.map(s => s.user_id),
                                    enrollmentIds: selected.map(s => s.enrollmentId || (s.user_info && s.user_info.enrollmentId)),
                                    students: selected, // pass the selected student objects for branchId extraction
                                    parentContactNumber: selected.map(s => s.user_info.parentContactNo),

                                    sectionId: selected.map(s => s.sectionId || (s.user_info && s.user_info.sectionId)),
                                    gradeId: selected.map(s => s.gradeId || (s.user_info && s.user_info.gradeId)),
                                    branchId: selected.map(s => s.branchId || (s.user_info && s.user_info.branchId)),
                                    boardId: selected.map(s => s.boardId || (s.user_info && s.user_info.boardId)),
                                    classId: selected.map(s => s.classId || (s.user_info && s.user_info.classId)),
                                    sectionName: selected.map(s => s.sectionName || (s.user_info && s.user_info.sectionName)),
                                    gradeName: selected.map(s => s.gradeName || (s.user_info && s.user_info?.["custom:grade"])),
                                    branchName: selected.map(s => s.branchName || (s.user_info && s.user_info.branchName)),
                                    boardName: selected.map(s => s.boardName || (s.user_info && s.user_info?.["custom:board"])),
                                };
                                console.log("Payload being sent:", payload);
                                this.props.setValues(payload);
                            }
                        }}
                    >
                        Search
                    </Button>

                    <Button
                        style={{
                            marginTop: "25px",
                            marginLeft: "10px",
                            height: "44px",
                            width: "44px",
                            borderRadius: "8px",
                            fontSize: "16px",
                            background: "#f8f9fa",
                            color: "#495057",
                            border: "1px solid #dee2e6",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                        tooltip="Refresh student data"
                        tooltipOptions={{ position: 'top' }}
                        onClick={() => this.props.fetchStudents()}
                    >
                        <i className="pi pi-refresh"></i>
                    </Button>

                </div>


                {loading && <div>Loading...</div>}
            </>
        );
    }
}

// const mapStateToProps = (state) => ({
//     students: state.studentData.students,
//     loading: state.studentData.loading
// });

// In mapStateToProps
const mapStateToProps = (state) => ({
    students: state.studentData.students,
    loading: state.studentData.loading,
    loaded: state.studentData.loaded
});

// Use forwardRef to allow refs to be passed to the connected component
const ConnectedClassetStudentSearchFilter = connect(mapStateToProps, { fetchStudents })(ClassetStudentSearchFilter);

// Wrap with forwardRef to properly forward refs
const ForwardedClassetStudentSearchFilter = React.forwardRef((props, ref) => (
    <ConnectedClassetStudentSearchFilter {...props} forwardedRef={ref} />
));

export default ForwardedClassetStudentSearchFilter;